import { createEntityQuery } from '@packages/api-client';
import {
  NotificationSharedService,
  type Wealthlane_NotificationService_DTOs_BellNotificationDto,
} from '@wealthlane/api-services/wealthlane-notification-service';

const useQuery = createEntityQuery<
  Wealthlane_NotificationService_DTOs_BellNotificationDto[],
  void
>({
  queryKey: ['getGetUnseenNotificationList'],
  queryFn: () =>
    NotificationSharedService.getApiNotificationApiAppNotificationNotifications(),
});

export function useGetUnseenNotification(enabled = true) {
  return useQuery(undefined, { enabled });
}
